"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Lookup
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupListsApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class LookupListsApi extends runtime.BaseAPI {
    /**
     * Put a list
     */
    async adminPutListRaw(requestParameters) {
        if (requestParameters.putList === null || requestParameters.putList === undefined) {
            throw new runtime.RequiredError('putList', 'Required parameter requestParameters.putList was null or undefined when calling adminPutList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/admin/put-list`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PutListToJSON(requestParameters.putList),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Put a list
     */
    async adminPutList(requestParameters) {
        await this.adminPutListRaw(requestParameters);
    }
    /**
     * Get all categories
     */
    async getCategoriesRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling getCategories.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        const response = await this.request({
            path: `/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.CategoryFromJSON));
    }
    /**
     * Get all categories
     */
    async getCategories(requestParameters) {
        const response = await this.getCategoriesRaw(requestParameters);
        return await response.value();
    }
    /**
     * Get lists for given categories
     */
    async listRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling list.');
        }
        if (requestParameters.categories === null || requestParameters.categories === undefined) {
            throw new runtime.RequiredError('categories', 'Required parameter requestParameters.categories was null or undefined when calling list.');
        }
        const queryParameters = {};
        if (requestParameters.categories) {
            queryParameters['categories'] = requestParameters.categories;
        }
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        const response = await this.request({
            path: `/lookup`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.LookupListFromJSON));
    }
    /**
     * Get lists for given categories
     */
    async list(requestParameters) {
        const response = await this.listRaw(requestParameters);
        return await response.value();
    }
}
exports.LookupListsApi = LookupListsApi;
//# sourceMappingURL=LookupListsApi.js.map